import { render, staticRenderFns } from "./FriendsMembers.vue?vue&type=template&id=6ca1899d"
import script from "./FriendsMembers.vue?vue&type=script&lang=js"
export * from "./FriendsMembers.vue?vue&type=script&lang=js"
import style0 from "./FriendsMembers.vue?vue&type=style&index=0&id=6ca1899d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports